module.exports = __webpack_public_path__ + "static/image-executive.bf72d8e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/image-executive.jpg
// module id = 373
// module chunks = 35783957827783 114276838955818